import { Injectable } from "@angular/core";
import {
  CanActivate,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { Router } from "@angular/router";
import { AuthService } from "../../providers/auth.service";
import { TotpAuthRoutingService } from "../../providers/totp-auth-routing.service";
import { Users } from "../model/user";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private totpAuthRouting: TotpAuthRoutingService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser: Users = this.authService.getUser;

    if (currentUser && currentUser?.accessToken) {
      return true;
    }

    if (this.totpAuthRouting.guardRedirect(currentUser, state.url)) {
      return false;
    }

    else if (currentUser && currentUser?.mfaRequired) {
      this.router.navigate(["/auth/mfa"]);
    }

    // not logged in so redirect to login page with the return url
    //console.log(state.url);
    if (state.url == "/dashboard") {
      this.router.navigate(["/auth/login"]);
    } else {
      // Preserve hash fragment (e.g. #ippBlinkHandoff=...) when AuthGuard redirects.
      const hash =typeof window !== "undefined" && window.location.hash? window.location.hash: "";
      const returnUrl = `${state.url}${hash}`;
      this.router.navigate(["/auth/login"], {
        queryParams: { returnUrl },
      });
    }

    return false;
  }
}
